<template>
  <div :id="id" class="modal fade" style="z-index: 9997">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" style="border: 1px solid black">
        <div class="modal-header">
          <modal-close-button @confirmed="abbrechen" />
          <h4 class="modal-title">{{ $t("global.searchperson") }}</h4>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-xl-3">
              <single-select-firma
                id="firma"
                :firma="firma"
                :editable="editCompany"
                :allowOpen="openCompany"
                :label="$t('global.company')"
                @confirmed="setFirma"
              />
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input
                  ref="editName"
                  v-model.trim="name"
                  class="form-control"
                  placeholder=" "
                  @keyup.enter="resetLoading()"
                />
                <label>{{ $t("global.surname") }}</label>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input
                  v-model.trim="vorname"
                  class="form-control"
                  placeholder=" "
                  @keyup.enter="resetLoading()"
                />
                <label>{{ $t("global.firstname") }}</label>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input
                  v-model.trim="zip"
                  class="form-control"
                  placeholder=" "
                  @keyup.enter="resetLoading()"
                />
                <label>{{ $t("global.zipcode") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 block modal-liste br-t-l-0">
              <div style="height: 300px !important">
                <b-table
                  responsive
                  sticky-header
                  selectable
                  select-mode="single"
                  @row-dblclicked="rowDblClick"
                  @row-selected="onRowSelected"
                  tbody-tr-class="item"
                  :items="geschaeftspartner"
                  :fields="fields"
                  :busy="isBusy"
                  :show-empty="loaded"
                >
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>

                  <template #empty>
                    <div class="text-center text-primary my-2">
                      {{ $t("global.nodatafound") }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <router-link
            v-if="berechtigungen.m_geschaeftspartner.create"
            class="btn btn-success mr-auto"
            :to="{ name: 'geschaeftspartner', params: { anzeige: 0 } }"
            target="_blank"
          >
            <font-awesome-icon icon="fa-regular fa-plus" class="mr-2" />
            {{ $t("global.newPerson") }}
          </router-link>

          <button type="button" class="btn btn-default" @click="abbrechen">
            {{ $t("global.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="entfernen"
            v-if="filterPerson && filterPerson.name && remove"
          >
            {{ $t("global.remove") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="uebernehmen"
            :disabled="selected.length == 0"
          >
            {{ $t("global.apply") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/Api";
import ModalCloseButton from "@/components/global/ModalCloseButton";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import { BSpinner } from "bootstrap-vue";

export default {
  name: "gpSucheModal",
  components: {
    ModalCloseButton,
    SingleSelectFirma,
    BSpinner,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: "geschaeftspartner-modal",
    },
    editCompany: {
      type: Boolean,
      required: false,
      default: true,
    },
    openCompany: {
      type: Boolean,
      required: false,
      default: true,
    },
    adressTypen: {
      type: Array,
      required: false,
    },
    filterRollen: {
      type: Array,
      required: false,
    },
    filterPerson: {
      type: Object,
      required: false,
    },
    filterFirma: {
      type: Object,
      required: false,
    },
    remove: {
      type: Boolean,
      default: false,
    },
    activeonly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isBusy: false,
      loaded: false,
      anzahlProPage: 99,
      geschaeftspartner: [],
      firma: null,
      vorname: null,
      name: "",
      zip: null,
      selected: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "name", sortable: true, label: this.$t("global.surname") },
        {
          key: "vorname",
          sortable: true,
          label: this.$t("global.firstname"),
        },
        {
          key: "mailadressen[0].bezeichnung",
          sortable: true,
          label: this.$t("global.email"),
        },
        {
          key: "adressen[0].plz",
          sortable: true,
          label: this.$t("global.zip"),
        },
        {
          key: "adressen[0].ort",
          sortable: true,
          label: this.$t("global.city"),
        },
        { key: "telefon_g", sortable: true, label: this.$t("global.phoneb") },
        { key: "telefon_p", sortable: true, label: this.$t("global.phonep") },
        { key: "telefon_m", sortable: true, label: this.$t("global.phonem") },
        {
          key: "aktivitaetsstatus.bezeichnung",
          sortable: true,
          label: this.$t("global.status"),
        },
      ];
    },
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.activeonly) params.status = "1737FA777AA";

      params.adresstyp = this.adressTypen ? this.adressTypen.join() : null;
      params.rollen = this.filterRollen ? this.filterRollen.join() : null;
      params.firma = this.firma?.id;
      params.filterFirma = this.filterFirma?.id;
      params.name = this.name;
      params.suche = this.vorname;
      params.zip = this.zip;

      params.typ = "17EF8844E6B";
      params.incf = "1";

      return params;
    },
  },
  watch: {
    filterFirma(val) {
      this.resetLoading();
    },
  },
  mounted() {
    this.$bus.$on("openGeschaeftspartnerModal", (id) => {
      if (id == this.id && !this.shown) this.openModal();
    });
  },
  methods: {
    openModal() {
      this.$bus.$emit("sucheModalOpen");
      this.vorname = null;
      this.name = null;
      this.firma = null;
      this.zip = null;
      this.geschaeftspartner = [];

      this.shown = true;

      let that = this;

      if (this.filterPerson?.id) {
        this.vorname = this.filterPerson?.vorname;
        this.name = this.filterPerson?.name;

        this.resetLoading();
      }

      if (this.filterFirma?.id) {
        this.firma = this.filterFirma;
        this.resetLoading();
      }

      $("#" + this.id).on("shown.bs.modal", function () {
        if (that.$refs && that.$refs.editName) that.$refs.editName.focus();
      });

      $("#" + this.id).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeModal() {
      this.$bus.$emit("sucheModalClose");
      this.shown = false;
      $("#" + this.id).modal("hide");
    },

    onRowSelected(items) {
      this.selected = items;
    },

    rowDblClick(item) {
      this.selected = [item];
      this.uebernehmen();
    },

    setFirma(firma) {
      this.firma = firma;
      this.$emit("updatefirma", firma);
      //this.resetLoading();
    },

    resetLoading() {
      this.isBusy = true;

      Api.get("geschaeftspartner/", {
        params: this.queryParams,
      })
        .then((response) => {
          //response.data.shift();
          this.geschaeftspartner = response.data;
        })
        .finally(() => {
          this.isBusy = false;
          this.loaded = true;
        });
    },

    entfernen() {
      this.closeModal();
      this.$emit("confirmed", { personName: this.$t("global.notlinked") });
    },

    uebernehmen() {
      if (this.selected == null || this.selected.length == 0) return;
      this.closeModal();
      this.$emit("confirmed", this.selected);
    },

    abbrechen() {
      this.closeModal();
    },
  },
};
</script>

<style></style>
